import React from "react";
import { Route, Routes } from "react-router-dom";
import { ContentLayout } from "../components/contentLayout";
import { FloatButton } from "antd";
import { QuestionCircleOutlined, WhatsAppOutlined } from "@ant-design/icons";
import { IMAGES } from "../constants/images";

import Cadastro from "../pages/cadastro";
import Login from "../pages/login";
import RecuperarSenha from "../pages/recuperacaoSenha";

const styles = {
  containerCadastro: {
    backgroundImage: `url(${IMAGES.backgroundCadastro})`,
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
  },
};

const PublicRoutes = () => {
  return (
    <ContentLayout className="container" style={styles.containerCadastro}>
      <Routes>
        <Route path="*" element={<Cadastro />} />
        <Route path="/login" element={<Login />} />
        <Route path="/recuperacao-senha" element={<RecuperarSenha />} />
      </Routes>

      <FloatButton.Group trigger="click" style={{ right: 24 }} icon={<QuestionCircleOutlined />}>
        <FloatButton icon={<WhatsAppOutlined />} onClick={() => window.open("https://wa.me/message/WKIFUWDNKN2FG1")} />
      </FloatButton.Group>
    </ContentLayout>
  );
};

export default PublicRoutes;
